import React = require("react");

interface BadgeProps {
    innerText: string;
    color: string;
    backgroundColor: string;
    height?: number | string;
    width?: number | string;
}

export class LegacyBadge extends React.Component <BadgeProps, {}> {


    constructor(props: BadgeProps) {
        super(props);
    }

    public render() {
        return (
            <div
                className="colored-circle"
                style={{
                    backgroundColor: this.props.backgroundColor,
                    color: this.props.color,
                }}
            >
                {this.props.innerText}
            </div>
        );
    }
}
